import { Component } from '@angular/core';

@Component({
  selector: 'app-guest-layout',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: [
  ]
})
export class GuestLayoutComponent {

}
